// currencies.js
const currencyList = {
  AUD: {
    symbol: "$",
    name: "Australian dollar",
  },
  BGN: {
    symbol: "лв",
    name: "Bulgarian lev",
  },
  BRL: {
    symbol: "R$",
    name: "Brazilian real",
  },
  CAD: {
    symbol: "$",
    name: "Canadian dollar",
  },
  CHF: {
    symbol: "Fr",
    name: "Swiss franc",
  },
  CNY: {
    symbol: "¥",
    name: "Chinese yuan",
  },
  CZK: {
    symbol: "Kč",
    name: "Czech koruna",
  },
  DKK: {
    symbol: "kr",
    name: "Danish krone",
  },
  EUR: {
    symbol: "€",
    name: "Euro",
  },
  GBP: {
    symbol: "£",
    name: "British pound",
  },
  HKD: {
    symbol: "$",
    name: "Hong Kong dollar",
  },

  HUF: {
    symbol: "Ft",
    name: "Hungarian forint",
  },
  IDR: {
    symbol: "Rp",
    name: "Indonesian rupiah",
  },
  ILS: {
    symbol: "₪",
    name: "Israeli new shekel",
  },
  INR: {
    symbol: "₹",
    name: "Indian rupee",
  },
  ISK: {
    symbol: "kr",
    name: "Icelandic króna",
  },
  JPY: {
    symbol: "¥",
    name: "Japanese yen",
  },
  KRW: {
    symbol: "₩",
    name: "South Korean won",
  },
  MXN: {
    symbol: "$",
    name: "Mexican peso",
  },
  MYR: {
    symbol: "RM",
    name: "Malaysian ringgit",
  },
  NOK: {
    symbol: "kr",
    name: "Norwegian krone",
  },
  NZD: {
    symbol: "$",
    name: "New Zealand dollar",
  },
  PHP: {
    symbol: "₱",
    name: "Philippine peso",
  },
  PLN: {
    symbol: "zł",
    name: "Polish złoty ",
  },
  RON: {
    symbol: "lei",
    name: "Romanian leu",
  },

  SEK: {
    symbol: "kr",
    name: "Swedish krona",
  },
  SGD: {
    symbol: "$",
    name: "Singapore dollar",
  },
  THB: {
    symbol: "฿",
    name: "Thai baht",
  },
  TRY: {
    symbol: "₺",
    name: "Turkish lira",
  },
  USD: {
    symbol: "$",
    name: "United States dollar",
  },
  ZAR: {
    symbol: "R",
    name: "South African rand",
  },
};

export default currencyList;
